export default __webpack_public_path__ + "static/media/delete.eddf2ef3.svg";